'use client';

import React from 'react';
import cx from 'clsx';
import { useTranslations } from 'next-intl';

interface Props {
  height?: string;
  children?: React.ReactNode;
  className?: string;
  color?: string;
}

const Loading = (props: Props) => {
  const { children, className, color, height = '100%' } = props;
  const t = useTranslations('home');

  return (
    <div
      className={cx(
        'w-full h-full flex items-center justify-center text-base text-center text-gray-400',
        className
      )}
      style={{
        height,
        color,
      }}
    >
      <div className="flex items-center justify-center p-4 text-tertiary text-ss gap-2">
        {t('state.loading')}
        <div className="flex gap-1">
          <span className="animate-bounce" style={{ animationDelay: '0ms' }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: '150ms' }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: '300ms' }}>.</span>
        </div>
      </div>
      {!!children && (
        <div className="mt-2">
          {children}
        </div>
      )}
    </div>
  );
};

export default Loading;